import { MapPin, CalendarClock, Camera, BarChart3, WifiOff, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  {
    icon: MapPin,
    title: "Geo-verified check-ins",
    body: "Ambassadors clock in only when they’re physically on-site. GPS + geofence stamps every activation with location and time.",
  },
  {
    icon: CalendarClock,
    title: "Shift scheduling",
    body: "Build routes, assign crews, and dispatch shifts in seconds. Reps get their schedule, map, and brief right in-app.",
  },
  {
    icon: Camera,
    title: "Photo proof of work",
    body: "Capture branded setups, crowds, and samples handed out. Timestamped photo reports flow straight to the dashboard.",
  },
  {
    icon: BarChart3,
    title: "Live dashboards",
    body: "Watch every market in real time — coverage, samples scanned, leads captured, hours worked. Export to payroll in a click.",
  },
  {
    icon: WifiOff,
    title: "Works offline",
    body: "Basements, festivals, dead zones — GROUNDWORK caches everything locally and syncs the second signal returns.",
  },
  {
    icon: Users,
    title: "Team chat & briefs",
    body: "Broadcast updates, drop assets, and keep every crew on-message with threaded chat tied to each activation.",
  },
];

export const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="bg-paper text-ink">
      <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
        <Reveal className="mb-14 flex flex-col gap-6 border-b-2 border-ink pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-orange">/ Key features</p>
            <h2 className="font-bebas text-5xl uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl">
              Everything the <br /> field needs. Nothing it doesn’t.
            </h2>
          </div>
          <p className="max-w-sm font-mono text-sm leading-relaxed text-muted2">
            One app for managers and reps. Built loud, flat, and functional — so the work gets done on the
            pavement, not in a spreadsheet.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 border-2 border-ink md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal
                key={f.title}
                delay={(i % 3) * 0.08}
                className="group relative border-b-2 border-ink p-8 last:border-b-0 md:border-r-2 md:[&:nth-child(2n)]:border-r-0 lg:[&:nth-child(2n)]:border-r-2 lg:[&:nth-child(3n)]:border-r-0"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center border-2 border-ink bg-ink transition-colors duration-300 group-hover:bg-orange">
                  <Icon size={24} className="text-paper" />
                </div>
                <h3 className="font-bebas text-3xl uppercase leading-none tracking-tight">{f.title}</h3>
                <p className="mt-4 font-mono text-sm leading-relaxed text-muted2">{f.body}</p>
                <span className="absolute right-6 top-6 font-mono text-xs text-ink/30">
                  0{i + 1}
                </span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
